import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import "./header.css";
import {
  Container,
  Select,
  MenuItem,
  Typography,
  FormControl,
} from "@mui/material";

import Logo from "../assets/logo.jpg";

import EnglandFlag from "../assets/united-kingdom.png";
import SaudiFlag from "../assets/saudi-arabia.png";
import { useTranslation } from "react-i18next";
const Header = ({ direction, setDirection }) => {
  const [t,i18n]=useTranslation()

  const options = [
    { value: "en", label: "English", imageUrl: EnglandFlag },
    { value: "ar", label: "العربية", imageUrl: SaudiFlag },
  ];
  const lang = localStorage.getItem("lang");

  if (lang === null) {
    localStorage.setItem("lang", "en");
  }

  const [language, setLanguage] = useState(lang);

  useEffect(() => {
    setLanguage(lang);
  }, [lang]);

  const handleSelect = (e) => {
    setLanguage(e.target.value);
    setDirection(e.target.value);
    // console.log(e.target.value)
    // i18n.changeLanguage(e.target.value);
    document.documentElement.setAttribute('lang', e.target.value);
    
  };

  return (
    <Box sx={{ flexGrow: 1, marginBottom: "4rem" }}>
      <AppBar
        position="fixed"
        style={{
          backgroundColor: "white",
          direction: `${lang === "ar" ? "rtl" : "ltr"}`,
        }}
      >
        <Container>
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <FormControl style={{ width: "120px" }}>
              <Select
                fullWidth
                variant="standard"
                disableUnderline
                value={language}
                onChange={handleSelect}
                className={`${
                  direction === "ar" ? "arabic-select" : "english-select"
                }`}
                renderValue={(selectedValue) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flex: "1",
                      justifyContent: "space-around",
                      flexDirection: direction === "en" ? "row" : "row-reverse",
                    }}
                  >
                    <img
                      src={
                        options.find((option) => option.value === selectedValue)
                          ?.imageUrl
                      }
                      alt={selectedValue}
                      style={{
                        width: "20px",
                        marginRight: direction === "en" ? "8px" : "8px",
                      }}
                    />
                    <Typography
                      style={{
                        marginRight: direction === "en" ? "10px" : "10px",
                      }}
                    >
                      {selectedValue}
                    </Typography>
                  </div>
                )}
              >
                {options.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      flexDirection: "row",
                      gap: "8px",
                    }}
                  >
                    <img
                      src={option.imageUrl}
                      alt={option.label}
                      style={{
                        width: "20px",
                        marginRight: direction === "en" ? "8px" : "0",
                        marginLeft: direction === "ar" ? "8px" : "0",
                      }}
                    />

                    <Typography>{option.label}</Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Box style={{ width: "60px", height: "60px" }}>
              <img
                style={{ width: "100%", height: "100%" }}
                src={Logo}
                alt="logo"
              />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};

export default Header;
